<template>
  <div v-if="fileList && fileList.length" class="widget-filer-viewer-wrapper">
    <FileViewer
      :title="title"
      :pkg="pkg"
      :all-downloadable="false"
      :original-file-list="fileList"
      :show-all-authority="showAllAuthority"
    ></FileViewer>
  </div>
</template>

<script>
import { asyncImport } from '@/utils'
import { THIRD_API } from '@/global/config'

const { asyncComponent } = asyncImport

export default {
  components: {
    FileViewer: asyncComponent('fileViewer/FileViewer')
  },
  props: {
    title: {
      type: String,
      default: '文档与视频'
    },
    data: {
      type: Object,
      default: () => ({})
    },
    pkg: {
      type: Object,
      default: () => ({})
    },
    showAllAuthority: Boolean
  },
  data() {
    return {
      fileList: []
    }
  },
  created() {
    this.getFileList()
  },
  methods: {
    async getFileList() {
      const ids = this.data.source.map(value => value.id).join(',')
      if (!ids) {
        return
      }
      const res = await this.$http.get(THIRD_API.alkFileList.link, {
        params: {
          id: ids
        }
      })
      const { data } = res
      if (
        data &&
        Object.prototype.toString.call(data) === '[object Array]' &&
        data.length
      ) {
        // 暂时在这个地方针对文件-下载序列特殊处理
        // 视频文件的占位图，原先的逻辑如下：这个地方只是一个文件列表，所以没法处理下面的这个逻辑，只能不处理
        // 普通文件，用其自身，或列表第一张图
        // 视频文件，如果排在第一位，需要用第一张banner图，非第一位，用默认占位图
        this.fileList = data.map((value, index) => {
          value.fileId = value.fileId || index
          value.singleDownloadable = true
          // 为了与旧的接口兼容，此处设置value.name和value.type属性
          value.name = value.alias || value.name
          value.type = value.type || value.postfix
          return value
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-filer-viewer-wrapper {
  .file-viewer-wrapper {
    height: 362px;
  }
}
</style>

<style lang="scss">
.widget-filer-viewer-wrapper {
  margin: 16px 0;
  .file-viewer-wrapper {
    &.normal {
      .list-container {
        .list-wrapper {
          width: 260px;
          padding-right: 20px;
        }
        .list-content {
          padding-left: 16px;
        }
        .list-toggle {
          display: none;
        }
      }
    }
  }
}
</style>
